;(function () {
	window.BmApi = window.BmApi || {};
	const form = document.forms['contact-form'];
	const resultEl = form.querySelector( '.form__result' );
	const button = form.querySelector( 'button' );
	const buttonLabel = button.querySelector( 'span' );
	let messageTimeout = undefined;

	if ( ! form ) {
		return;
	}

	form.addEventListener( 'submit', e => {
		e.preventDefault();
		submitContactForm();
	});

	function submitContactForm() {
		const request = new XMLHttpRequest();
		const data = new FormData( form );

		form.classList.add( 'form--submitting' );

		animateButton();

		hideResultEl();

		if ( messageTimeout ) {
			clearTimeout( messageTimeout );
		}

		request.open( 'POST', window.BmContact.ajaxUrl );
		request.onload = function () {
			const response = request.response ?
				JSON.parse( request.response ) :
				'';

			resultEl.innerHTML = response.data.message || '';
			showResultEl();

			if ( 200 === request.status ) {
				form.querySelectorAll( '.active' ).forEach( elem => elem.classList.remove( 'active' ) );
				resultEl.classList.remove( 'error-msg' );
				form.reset();
				window.dataLayer.push({
					event: 'form-submit'
				});
				messageTimeout = setTimeout( hideResultEl, 10000 );
			} else {
				resultEl.classList.add( 'error-msg' );
				console.error( request.response );
			}

			form.classList.remove( 'form--submitting' );

			reAnimateButton();

			if ( window.grecaptcha ) {
				window.grecaptcha.reset();
			}
		};
		request.send( data );
	}

	window.submitContactForm = submitContactForm;

	function showResultEl() {
		resultEl.style.transition = 'opacity .15s ease-out';
		resultEl.style.opacity = '1';
	}

	function hideResultEl() {
		resultEl.style.transition = 'opacity .3s ease-out';
		resultEl.style.opacity = '0';
	}

	resultEl.addEventListener( 'transitionend', e => {
		if ( resultEl.style.opacity === '0' ) {
			resultEl.innerText = '';
		}
	});

	const loadingIndicator = document.createElement( 'div' );
	loadingIndicator.classList.add( 'loading-indicator' );
	button.style.overflow = 'hidden';
	button.appendChild( loadingIndicator );
	buttonLabel.style.display = 'inline-block';

	function animateButton() {
		button.disabled = true;
	}

	button.addEventListener( 'click', _ => animateButton() );

	function reAnimateButton() {
		button.disabled = false;
	}

	form.message.addEventListener( 'keyup', e => {
		adjustHeight( e.srcElement );
	});

	form.message.addEventListener( 'input', e => {
		adjustHeight( e.srcElement );
	});

	function adjustHeight( element ) {
		const scrollHeight = element.scrollHeight;
		const offsetHeight = element.offsetHeight;

		if ( scrollHeight > offsetHeight ) {
			element.style.height = `${scrollHeight + 1}px`;
		}
	}

	form.querySelectorAll( 'input,textarea' ).forEach( elem => {
		const label = elem.parentElement;

		elem.addEventListener( 'input', _ => {
			if ( '' === elem.value ) {
				label.classList.remove( 'active' );
			} else {
				label.classList.add( 'active' );
			}
		});
	});
}());

(function () {
	const recaptchaScriptTag = document.querySelector( '#recaptcha-js' );
	const contactForm = document.forms['contact-form'];

	if ( ! recaptchaScriptTag || ! contactForm ) {
		return;
	}

	function loadRecaptcha() {
		recaptchaScriptTag.src = recaptchaScriptTag.dataset.src;
	}

	if ( ! window.IntersectionObserver ) {
		loadRecaptcha();
	} else {
		const io = new IntersectionObserver( entries => {
			if ( entries[0].intersectionRatio <= 0 ) {
				return;
			}

			loadRecaptcha();
			io.unobserve( contactForm );
		}, {
			rootMargin: '100px 100px 100px 100px',
		} );

		io.observe( contactForm );
	}
})();
